import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5004/api';

export interface UploadFileResult {
    key: string;
    url: string;
    fileName: string;
    contentHash: string;
}

export const fileService = {
    /**
     * Upload a file to R2 storage
     * @param file File to upload
     * @param folder Folder path (e.g., 'avatars/companies', 'avatars/users')
     */
    uploadFile: async (file: File, folder: string = 'temp'): Promise<UploadFileResult> => {
        const formData = new FormData();
        formData.append('file', file);

        // Get token from sessionStorage (same as companiesService)
        const authUser = sessionStorage.getItem('authUser');
        let token = null;
        if (authUser) {
            const user = JSON.parse(authUser);
            token = user?.token;
        }

        try {
            const response = await axios.post<UploadFileResult>(
                `${API_BASE_URL}/files/upload?folder=${encodeURIComponent(folder)}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            // Note: The axios interceptor in api_helper.ts already returns response.data
            // So 'response' here is actually the data object itself, not the axios response
            // See docs/AXIOS_INTERCEPTOR_NOTE.md for details
            return response as any as UploadFileResult;
        } catch (error: any) {
            throw error;
        }
    },

    /**
     * Delete a file from R2 storage
     * @param fileKey The file key/path in R2
     */
    deleteFile: async (fileKey: string): Promise<void> => {
        // Get token from sessionStorage (same as companiesService)
        const authUser = sessionStorage.getItem('authUser');
        let token = null;
        if (authUser) {
            const user = JSON.parse(authUser);
            token = user?.token;
        }

        await axios.delete(
            `${API_BASE_URL}/files/${encodeURIComponent(fileKey)}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );
    }
};
